import { ExternalLinkIcon } from "@/Icons/v2/ExternalLink";

type Props = {
  name: string;
  link?: string;
};

export const ReportingTableNameCell: React.FC<Props> = ({ name, link }) => (
  <span className="inline-flex items-center gap-[6px] text-[13.5px] font-semibold text-[#1D1C1C]">
    {name}
    {link && (
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="inline-flex"
        onClick={(e) => e.stopPropagation()}
      >
        <ExternalLinkIcon />
      </a>
    )}
  </span>
);
